import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import moment from "moment";
export default class MeetingDetailDisplay extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.onCommentChange = this.onCommentChange.bind(this);
    }
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    onCommentChange(event) {
        this.props.onCommentChange(event.target.value);
    }
    renderLocationInfo() {
        if (this.props.location) {
            return (_jsxs("div", { className: "mt-3", children: [_jsx("span", { className: "fas fa-map-marker-alt", "aria-hidden": "true" }), " ", this.props.location.name, " - ", this.props.location.location.name] }));
        }
        return "";
    }
    render() {
        return (_jsxs("div", { children: [_jsx("h3", { className: "mt-3", children: this.props.meetingType.name }), this.props.meetingType.additionalInfo && (_jsx("p", { children: this.props.meetingType.additionalInfo })), _jsxs("div", { className: "mt-3", children: [moment(this.props.startTime).calendar(), " for", " ", this.props.durationMinutes, " minutes"] }), this.renderLocationInfo(), this.props.topic && this.props.topic.title && (_jsxs("div", { className: "mt-3", children: [_jsx("h4", { children: "Topic" }), _jsx("div", { children: _jsx("span", { className: "badge badge-secondary mx-1", children: this.props.topic.title }) })] })), this.props.comment && (_jsxs("div", { className: "mt-3", children: [_jsx("h4", { children: "Comments" }), this.props.allowCommentEdit ? (_jsx("textarea", { className: "form-control", rows: 3, value: this.props.comment, onChange: this.onCommentChange })) : (_jsx("div", { children: this.props.comment }))] }))] }));
    }
}
